import React, { useEffect, useState } from "react";
import { BACKEND_URL } from "@/lib/backendUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Users } from "lucide-react";

const API = `${BACKEND_URL}/api`;

/**
 * Horizontal strip in the Studio header showing recent published sets
 * from DJs the current user follows. Hidden if user isn't logged in
 * or has no follows.
 */
export default function FollowFeed() {
  const { user } = useAuth();
  const [sets, setSets] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { setSets([]); return; }
    setLoading(true);
    axios.get(`${API}/me/feed`)
      .then(r => setSets(r.data))
      .catch(() => setSets([]))
      .finally(() => setLoading(false));
  }, [user]);

  if (!user || sets.length === 0) return null;

  return (
    <div className="border-y border-[#1E2638] bg-[#0B0E14]/95 backdrop-blur-md px-4 py-2 relative z-30" data-testid="follow-feed-strip">
      <div className="flex items-center gap-3 max-w-[1920px] mx-auto">
        <div className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-[#00F0FF] flex-shrink-0">
          <Users className="w-3 h-3"/> New from your DJs
        </div>
        <div className="flex items-center gap-2 overflow-x-auto flex-1">
          {sets.map(s => (
            <Link key={s.id} to={`/set/${s.id}`} data-testid={`feed-set-${s.id}`}
              className="flex-shrink-0 px-3 py-1.5 rounded-full border border-[#1E2638] hover:border-[#00F0FF] hover:bg-[#00F0FF]/5 text-xs whitespace-nowrap transition-colors">
              <span className="text-white font-bold">{s.name}</span>
              <span className="text-[#94A3B8] ml-2">by {s.artist_name}</span>
              <span className="text-[#94A3B8] ml-2 font-mono">· {s.play_count} plays</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
